import { cn } from '@/shared/lib/utils';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Icon } from './Icon';

interface CheckboxProps {
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

/**
 * Figma "Checkbox + Text" — 20px 박스 + Body 15/R.
 * 기본: 1.5px grey-400 테두리 · 선택: primary-600 채움 + 흰 체크.
 */
export function Checkbox({ label, checked, onCheckedChange }: CheckboxProps) {
  return (
    <label className="flex cursor-pointer items-center gap-2">
      <CheckboxPrimitive.Root
        checked={checked}
        onCheckedChange={(next) => onCheckedChange(next === true)}
        className={cn(
          'flex size-5 shrink-0 items-center justify-center overflow-clip rounded-4 border-[1.5px] border-grey-400 bg-surface-white outline-none',
          'focus-visible:ring-2 focus-visible:ring-fg-accent/40 data-[state=checked]:border-0 data-[state=checked]:bg-primary-600',
        )}
      >
        <CheckboxPrimitive.Indicator>
          <Icon name="checkboxCheck" size={16} />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <span className="text-body-15 font-regular text-fg-primary">{label}</span>
    </label>
  );
}
